import * as React from "react";
import { TextField, InputBase } from "@material-ui/core";
import { MUIAdornment } from "../";
import { SvgIcon } from "../../../../components";
import { tl } from "../../../../utils";
import { label } from "../Forms/styles.scss";

interface IProps {
  disabled?: boolean;
  search: string;
  setSearch: (value: string) => void;
  onFilterSend: () => void;
  placeholder?: string;
  naked?: boolean;
  variant?: "filled" | "outlined" | "standard";
}

export const FilterSimple = (props: IProps) => {
  const onSearch = (e: any) => {
    props.setSearch(e.target.value);
  };
  return props.naked ? (
    <InputBase
      disabled={props.disabled}
      startAdornment={(
        <MUIAdornment>
          <button
            type="submit"
            aria-label={tl("Поиск")}
            disabled={props.disabled}
            onClick={props.onFilterSend}
          >
            <SvgIcon type="search" />
          </button>
        </MUIAdornment>
      )}
      endAdornment={props.search ? (
        <MUIAdornment>
          <button
            type="reset"
            aria-label={tl("Очистить")}
            onClick={() => {
              props.setSearch("");
            }}
            disabled={props.disabled}
          >
            <SvgIcon type="search-clear" />
          </button>
        </MUIAdornment>
      ) : null}
      inputProps={{
        'aria-label': tl("Поиск"),
      }}
      onChange={onSearch}
      placeholder={props.placeholder ? props.placeholder : tl("Поиск")}
      value={props.search}
    />
  ) : (
    <TextField
      disabled={props.disabled}
      fullWidth
      inputProps={{
        "aria-label": tl("Поиск"),
      }}
      InputProps={{
        startAdornment: (
          <MUIAdornment>
            <button
              type="submit"
              aria-label={tl("Поиск")}
              disabled={props.disabled}
              onClick={props.onFilterSend}
            >
              <SvgIcon type="search" />
            </button>
          </MUIAdornment>
        ),
        endAdornment: props.search ? (
          <MUIAdornment>
            <button
              type="reset"
              aria-label={tl("Очистить")}
              onClick={() => {
                props.setSearch("");
              }}
              disabled={props.disabled}
            >
              <SvgIcon type="search-clear" />
            </button>
          </MUIAdornment>
        ) : null,
      }}
      onChange={onSearch}
      placeholder={props.placeholder ? props.placeholder : tl("Поиск")}
      value={props.search}
      variant={props.variant || "outlined"}
    />
  );
};
